











import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'table-icon',

})
export default class TableIcon extends Vue {

  @Prop({type: [String], default: '#0A0A0A'}) protected color!: string
  @Prop({type: [String], default: 'delete'}) protected icon!: string

}

